import type { ChartPeriod } from '../../../pages/dslAgentTest/chartPeriod';
import type { DslTag } from '../../../pages/dslAgentTest/types';

export interface MonitorChartLayout {
  id: string;
  title: string;
  period: ChartPeriod;
  tags: DslTag[];
}

export const newId = (prefix: string): string => {
  const cryptoRef = (globalThis as { crypto?: Crypto }).crypto;
  if (cryptoRef && typeof cryptoRef.randomUUID === 'function') {
    return cryptoRef.randomUUID();
  }
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}_${Date.now()}`;
};
